import * as React from "react"
import injectSheet from "react-jss"
import { t } from "@/i18n"
import { LOADING } from "@/helpers/stateMachine"
import { Text } from "@xingternal/360-components"
import { LoadingText } from "@xingternal/winery-ui/lib/LoadingText"

const styles = {
  comparison: {
    composes: "flex items-center gray-60",
  },
  text: { lineHeight: 1 },
}

const ComparisonToDateRange = ({
  classes,
  comparisonValue,
  formatter,
  status,
  value,
}) => (
  <div className={classes.comparison}>
    {status === LOADING ? (
      <LoadingText data-testid="loadingText" min={50} max={70} />
    ) : (
      <Text className={classes.text} size={13} data-testid="formattedText">
        {t("360_RECRUITER_INSIGHTS_COMPARE_KPI_VALUES", {
          previous: formatter(comparisonValue),
          current: formatter(value),
        })}
      </Text>
    )}
  </div>
)

ComparisonToDateRange.defaultProps = {
  classes: {},
}

export const StyledComparisonToDateRange = injectSheet(styles)(
  ComparisonToDateRange,
)
export default ComparisonToDateRange
